var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenaamSvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 34,
    viewBox: "0 0 53 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Benaam - SVG Logo 1",
    clipPath: "url(#clip0_360_40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M53 2.58691H49.2676V6.28257H53V2.58691Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M25.7539 10.7173H22.0215V14.4129H25.7539V10.7173Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M0 8.86957V2.95652H41.8028V0H47.7746V8.86957H0Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M41.8028 25.1304V28.0869H0V33.9999H47.7746V25.1304H41.8028Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M41.8028 12.5652V15.5217H5.97183V12.5652H0V21.4348H47.7746V12.5652H41.8028Z",
    fill: "#231F20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenaamSvgLogo1);
export default __webpack_public_path__ + "static/media/benaam-svg-logo-1.44aee244033cf2e886e1731e0dad08f6.svg";
export { ForwardRef as ReactComponent };